const API_KEY = "269d199a8cd3edb061c1e62c179ec32e"

const request = {
    trending: `/trending/all/week?api_key=${API_KEY}&language=en-US`,
    TopRated: `/movie/top_rated?api_key=${API_KEY}&language=eng-US`,
    actionMovies:`/discover/movie/?api_key=${API_KEY}&with_genres=28`,
    comedyMovies:`/discover/movie/?api_key=${API_KEY}&with_genres=35`,
    horrorMovies:`/discover/movie/?api_key=${API_KEY}&with_genres=27`,
    netflex:`discover/tv?api_key=${API_KEY}&with_networks-123`,
    series:`discover/tv?api_key=${API_KEY}&with_networks-123`
}

export default request